import { SubmitHandler, useForm } from 'react-hook-form';
import { Button } from '@m/alchemy-ui/Button';
import { Dialog } from '@m/alchemy-ui/Dialog';
import { Field } from '@m/alchemy-ui/Field';
import { Input } from '@m/alchemy-ui/Input';

import * as Styled from './SnappyApiDialog.styled';
import medalliaSnappySrc from '../../../../assets/images/medallia-snappy.svg';

type SnappyIntegrationInputs = {
  apiKey: string;
};

export function SnappyApiDialog({
  isOpen = false,
  onAccept = () => {},
  onDismiss = () => {},
}: SnappyApiDialogProps) {
  const {
    register,
    handleSubmit,
    formState,
  } = useForm<SnappyIntegrationInputs>({
    defaultValues: { apiKey: '' },
    mode: 'onChange',
  });

  if (!isOpen) return null;

  const { isDirty, isValid } = formState;
  const onSubmit: SubmitHandler<SnappyIntegrationInputs> = data =>
    onAccept(data.apiKey);

  return (
    <Dialog isOpen={isOpen} size="medium">
      <Dialog.Header>
        <Styled.Title>Connect to Snappy</Styled.Title>
      </Dialog.Header>

      <form
        onSubmit={event => {
          event.stopPropagation();
          handleSubmit(onSubmit)(event);
        }}
      >
        <Styled.ComfortableDialogBody>
          <Styled.MedalliaSnappyLogo
            src={medalliaSnappySrc}
            alt="Connect Snappy with Agent Connect"
          />

          <Styled.Description>
            Connect to your Snappy account by pasting your Snappy API Key in
            below
          </Styled.Description>

          <Field
            required
            label="Enter API Key"
            isFullWidth
            input={<Input {...register('apiKey', { required: true })} />}
          />
        </Styled.ComfortableDialogBody>

        <Styled.RightAlignedDialogFooter>
          <Button onClick={onDismiss} priority="tertiary" type="button">
            Cancel
          </Button>

          <Button type="submit" disabled={!isDirty || !isValid}>
            Connect
          </Button>
        </Styled.RightAlignedDialogFooter>
      </form>
    </Dialog>
  );
}

interface SnappyApiDialogProps {
  isOpen?: boolean;
  onDismiss?: () => void;
  onAccept?: (apiKey: string) => void;
}
